import React, { useEffect, useState } from 'react'
import BaseModal from './BaseModal'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { setEditHorseWeightModal, setHorseToEdit } from '../../store/reducers/modal.reducer'
import { THorse } from '../../shared/types/horse.type'
import { Box, Checkbox, Divider, FormControl, FormControlLabel, InputAdornment, InputLabel, OutlinedInput, Stack, TextField } from '@mui/material'
import { isEmpty, isUndefined, toNumber } from 'lodash'
import { t } from 'i18next'
import { TUser } from '../../shared/types/user.type'
import { DatePicker } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import { LoadingButton } from '@mui/lab'
import { useHorses } from '../../hooks/useHorses'
import { toast } from 'react-toastify'
import { useQueryClient } from 'react-query'
import { useHorse } from '../../hooks/useHorse'
import HorseWeightsChart from '../horse/HorseWeightsChart'

import UTC from 'dayjs/plugin/utc'

dayjs.extend(UTC)

function EditHorseWeight() {
    const open = useSelector<RootState>(state => state.modals.horseWeightModal) as boolean
    const horse = useSelector<RootState>(state => state.modals.horseToEdit) as THorse | null
    const user = useSelector<RootState>(state => state.user.user) as TUser
    const dispatch = useDispatch()
    const { updateHorseWeightMutation, horseHeightsLoading, horseWeights } = useHorse({ enableQuery: false, horseStrId: horse?.['@id'], enableWeightsQuery: open })
    const query = useQueryClient()
    const [isRestro, setIsRestro] = useState(false)

    const [weight, setWeight] = useState(0)

    const [date, setDate] = useState<dayjs.Dayjs | null>(null)

    const handleClose = () => {

        dispatch(setEditHorseWeightModal(false))
        dispatch(setHorseToEdit(null))
        clearInputs()
    }

    const clearInputs = () => {
        setWeight(0)
        setIsRestro(false)
        setDate(null)
    }

    const updateHorse = async () => {
        if (!horse) return
        try {
            let _weight = user?.unit_system === 'metric' ? weight : Math.round(weight * 2.2)

            await updateHorseWeightMutation.mutateAsync({ horse: horse?.['@id'], weight: _weight, ...(isRestro && date ? { start_date: date.utc(true).toISOString() } : {}) })

            toast(t('addHorse:editSuccess'), { type: 'success' })

            query.refetchQueries({ queryKey: ['horse_weights', horse['@id']] })
            query.refetchQueries({ queryKey: ['horse', horse.id] })


            clearInputs()
        } catch (error) {
            toast(t('error:generic'), { type: 'error' })

        }
    }
    if(!open) return null

    return (
        <BaseModal
            open={open}
            handleClose={handleClose}
            title='settings:information'
            width={500}
        >
            <Stack direction={'column'} spacing={2}>

                {
                    !isEmpty(horseWeights) && <>
                        <HorseWeightsChart
                            isLoading={horseHeightsLoading}
                            data={horseWeights}
                        />
                        <Divider></Divider>
                    </>
                }

                <FormControl>
                    <InputLabel > {t('parameters:weight')}</InputLabel>
                    <OutlinedInput
                        endAdornment={<InputAdornment position="end">{t(user?.unit_system === 'imperial' ? 'units:lbShort' : 'units:kgShort')}</InputAdornment>}
                        label={t('parameters:weight')} value={weight} onChange={e => setWeight(toNumber(e.target.value))} type='number'></OutlinedInput>
                </FormControl>
                <FormControlLabel checked={isRestro} onChange={(_, checked) => {
                    setIsRestro(checked)
                    if (!checked) {
                        setDate(null)
                    }
                }} control={<Checkbox sx={{ pl: 0 }} />} label={t('parameters.applyRetrospectively')} />
                {
                    isRestro &&
                    <DatePicker
                        onChange={(value) => setDate(value)}
                        value={date}
                        maxDate={dayjs()}  //maxDate
                        label={t('date')} />
                }

                <Box display={'flex'} justifyContent={'end'}>
                    <LoadingButton loading={updateHorseWeightMutation.isLoading} onClick={updateHorse} variant='contained'>{t('button:save')}</LoadingButton>
                </Box>
            </Stack>
        </BaseModal>
    )
}

export default EditHorseWeight